// extracted by mini-css-extract-plugin
export default {"root":"NoLoansPanel_root__kOb77","hide":"NoLoansPanel_hide__pQXNx","description":"NoLoansPanel_description__MKO5B","buttons":"NoLoansPanel_buttons__udg-g"};